/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Keep_OrderInputs */

const en_orders_keep_order = /** @type {(inputs: Orders_Keep_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep Order`)
};

const es_orders_keep_order = /** @type {(inputs: Orders_Keep_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conservar pedido`)
};

/**
* | output |
* | --- |
* | "Keep Order" |
*
* @param {Orders_Keep_OrderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_keep_order = /** @type {((inputs?: Orders_Keep_OrderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Keep_OrderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_keep_order(inputs)
	return es_orders_keep_order(inputs)
});